module.exports = __webpack_public_path__ + "img/Jdiamante.d5682eb4.png";